<template>
  <div id="model-models">
    <!-- <h1>Model and Brands</h1> -->
    <!--<p class="mb-4"> <a href="#" rel="nofollow">Provisioning</a> Page to config the Vehicle</p>-->
    <!---->
    <List></List>
  </div>
</template>

<script>
import List from './VehicleModelList.vue'

export default {
  components: {
    List,
  },
}
</script>
